import React, { useContext, useState } from 'react'
import { PluginContext } from '@flamingo_tech/funkgo'
import Image from '@components/common/Image/Image'
import { withDrawer } from '../../common/Drawer/Drawer'
import cx from '../../../utils/className'

import styles from './InstallmentBar.module.css'

const paymentsImages = ['https://img.flamingo.shop/p/show/26ec3b04dafb4df28ca6252572a41f2a.png', 'https://img.flamingo.shop/p/show/cdb4f352f4434b4dbc56ce67a9073960.png']

const InstallmentPolicy = (props) => {
  return (
    <div className={cx(styles.policyWrapper, props.className)}>
      <div className={styles.title}>How it works:</div>
      <div>Select one of the following payment methods to shop now, pay later:</div>
      <div>
        <h3>Pay in 4 interest-free installments with Klarna<Image src={paymentsImages[0]} original className={styles.policyIcon}/></h3>
        <h3>Pay in 4 interest-free installments with Afterpay<Image src={paymentsImages[1]} original className={styles.policyIcon}/></h3>
      </div>
      <div>Klarna/Afterpay: You must be a resident of the United States or its territories. You must have full legal capacity to enter into a contract and be at least 18 years old or of legal age in your state of residence.</div>
    </div>
  )
}

const InstallmentPolicyDrawer = withDrawer(InstallmentPolicy)


const InstallmentBar = (props) => {
  const plugin = useContext(PluginContext)
  const isDesktop = plugin.$detector.isDesktop()
  const [showModal, setShowModal] = useState(false)

  if (!props.installmentPrice || props.installmentPrice <= 0) {
    return null
  }

  return (
    <>
      <div className={cx(styles.wrapper, isDesktop && styles.inDesktop)} onClick={() => setShowModal(true)}>
        <div className={styles.content}>Pay {props.displayInstallmentPrice} today
          <div className={styles.paymentIcons}>
            {
              paymentsImages.map(image => (
                <Image src={image} original key={image} className={styles.icon}/>
              ))
            }
          </div>
        </div>
      </div>
      {
        showModal &&
        <InstallmentPolicyDrawer headerTitle="Shop Now, Pay Later" onClose={() => setShowModal(false)} className={isDesktop && styles.inDesktop}/>
      }
    </>
  )
}






export default InstallmentBar